import { adminApiRequest } from "../../utils/apiUtils";

export const AppUpdateAPI = {
  updateAppUpdate: (body: any) => {
    return adminApiRequest.put("/app-update/update", body).then((res) => res);
  },
};
